var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsertAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,13.8c-0.8,0-1.5-0.4-2.1-0.9s-0.8-1.3-0.8-2.1c0-0.9,0.3-1.6,0.9-2.2c0.6-0.6,1.3-0.9,2.2-0.9 c0.8,0,1.5,0.3,2.1,0.8c0.6,0.6,0.9,1.3,0.9,2.1l-1.1-0.3c-0.1-0.5-0.3-0.8-0.7-1.1c-0.4-0.3-0.8-0.4-1.3-0.4 c-0.6,0-1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4c0,0.5,0.1,0.9,0.4,1.3c0.3,0.4,0.7,0.6,1.1,0.7L13.1,13.8z M13.8,15.8 c-0.1,0-0.2,0-0.2,0h-0.2c-0.7,0-1.4-0.1-2-0.4c-0.6-0.3-1.2-0.6-1.6-1.1s-0.8-1-1.1-1.6c-0.3-0.6-0.4-1.3-0.4-2 c0-0.7,0.1-1.4,0.4-2c0.3-0.6,0.6-1.2,1.1-1.6s1-0.8,1.6-1.1c0.6-0.3,1.3-0.4,2-0.4c0.7,0,1.4,0.1,2,0.4c0.6,0.3,1.2,0.6,1.6,1.1 s0.8,1,1.1,1.6c0.3,0.6,0.4,1.3,0.4,2V11c0,0.1,0,0.2,0,0.2l-1-0.3v-0.2c0-1.1-0.4-2.1-1.2-2.9c-0.8-0.8-1.8-1.2-2.9-1.2 S11.2,7,10.4,7.8s-1.2,1.8-1.2,2.9s0.4,2.1,1.2,2.9s1.8,1.2,2.9,1.2h0.2L13.8,15.8z M17.7,16.1l-2.2-2.2l-0.6,1.9l-1.5-5.1 l5.1,1.5l-1.9,0.6l2.2,2.2L17.7,16.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,16.1c-0.3,0.2-0.5,0.5-0.8,0.7c-1.9-1.7-3.3-3.3-4.2-4.8S4.3,9.4,4.3,8.3c0-1.7,0.5-3.1,1.6-4.2 c1.1-1.1,2.4-1.6,4-1.6s2.9,0.5,4,1.6c0.2,0.2,0.3,0.4,0.5,0.6c0.9,0.1,1.8,0.4,2.6,0.8c-0.4-1.1-1-2.1-1.8-2.9 c-1.5-1.4-3.2-2.1-5.2-2.1S6.1,1.4,4.6,2.7C3.1,4.1,2.4,6,2.4,8.3c0,1.6,0.6,3.2,1.9,5.1s3.1,3.8,5.6,5.9c1-0.8,1.9-1.7,2.7-2.5 C11.9,16.7,11.2,16.5,10.6,16.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertAction);
export default __webpack_public_path__ + "static/media/Insert-action.31c06af5acd1e8a94185b3805f8eaa11.svg";
export { ForwardRef as ReactComponent };